import React, { Component } from 'react';
import CalciteInput from '../../../shared/CalciteInput';

class SingleBarSearch extends Component {
	constructor(props) {
		super(props);
		this.initQuery = this.props.activeSearchQ;
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {

	}

	handleChange(event) {
		this.props.handleSearchChange(event.target.value);
		this.props.handleSubmit();
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.handleSubmit();
	}

	render() {
		let placeholder = this.props.labels.searchInputMessage;
		return (
			<section className="sra-search filterpage">
				<div className="filter-icon avenir-demi font-size-0">Filter</div>
				<div className="single-bar-search">
					<CalciteInput value={this.props.initQvalue} placeholder={placeholder} icon="magnifying-glass" scale="l" onChange={this.handleChange}></CalciteInput>
				</div>
			</section>
		);
	}
}

export default SingleBarSearch;
